<template>
  <div id="loader" class="loader loader-border is-active">
    <div class="loader-area">
      <div class="loader-inner">
        <div class="loader-image">
          <img src="../../../assets/Spin-1s-200px.gif" />
        </div>
        <p class="loader-text">頁面讀取中...</p>
      </div>
    </div>
  </div>

  <div class="mx-auto max-w-4xl items-center justify-between p-6 pt-1 lg:px-8">
    <div class="bg-white rounded-lg shadow-lg p-6 sm:p-8">
      <h1 class="title mb-5">
        中原大學學生關鍵能力評估問卷
      </h1>

      <!-- 問卷說明 -->
      <div class="mb-8 px-5 py-4 bg-gray-50 rounded-lg border border-gray-200">
        <p class="text-sm text-gray-700 mb-3">
          <span class="font-semibold">為了全面評估並提升學生的六大關鍵能力：</span>
        </p>
        <div class="text-base sm:text-lg text-gray-700  leading-relaxed mb-4">
          <span class="inline-block mr-5 mb-2">問題解決</span>
          <span class="inline-block mr-5 mb-2">自主學習</span>
          <span class="inline-block mr-5 mb-2">國際移動</span>
          <span class="inline-block mr-5 mb-2">跨領域能力</span>
          <span class="inline-block mr-5 mb-2">資訊科技與人文關懷</span>
          <span class="inline-block mb-2">社會參與</span>
        </div>
        <p class="text-sm text-gray-600 text-center pt-3 border-t border-gray-200">
          請根據您的實際情況填寫以下問卷，幫助我們了解您的關鍵能力發展狀況
        </p>
      </div>

      <form @submit.prevent="submitQuestionnaire">
        <!-- 基本資訊區塊 -->
        <div class="mb-8 px-5 py-4 bg-gray-50 rounded-lg border border-gray-200">
          <h2 class="text-xl font-bold mb-4 text-gray-800">基本資訊</h2>

          <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div class="form-group">
              <label class="block mb-2 text-base font-medium text-gray-700">
                <span class="text-red-500">*</span>學號 / Student ID
              </label>
              <InputText
                v-model="formData.studentId"
                class="w-full h-12 px-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent transition"
                placeholder="請輸入學號"
                :disabled="true"
              />
            </div>
            <div class="form-group">
              <label class="block mb-2 text-base font-medium text-gray-700">
                <span class="text-red-500">*</span>姓名 / Name
              </label>
              <InputText
                v-model="formData.studentName"
                class="w-full h-12 px-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent transition"
                placeholder="請輸入姓名"
                :disabled="true"
              />
            </div>

            <div class="form-group">
              <label class="block mb-2 text-base font-medium text-gray-700">
                電子郵件 / Email
              </label>
              <InputText
                v-model="formData.email"
                class="w-full h-12 px-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent transition"
                placeholder="請輸入電子郵件地址"
                type="email"
              />
            </div>
            <div class="form-group">
              <label class="block mb-2 text-base font-medium text-gray-700">
                手機號碼 / Phone Number
              </label>
              <InputText
                v-model="formData.phone"
                class="w-full h-12 px-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent transition"
                placeholder="請輸入手機號碼"
                type="tel"
              />
            </div>

            <div class="col-span-1 sm:col-span-2 mt-2 pt-3 border-t border-gray-300">
              <p class="text-sm text-gray-600">
                E-mail與手機號碼為非必填，僅供抽獎通知用，相關抽獎資訊每學期公告於本校行政公告。
              </p>
            </div>
          </div>
        </div>

        <!-- 題目區塊 -->
        <div v-if="isLoadingQuestions" class="text-center py-8">
          <p class="text-gray-600">載入題目中...</p>
        </div>
        <div v-else class="space-y-8">
          <!-- 依類別分組顯示題目 -->
          <div
            v-for="group in groupedQuestions"
            :key="group.category"
            class="space-y-4"
          >
            <h2
              class="text-lg sm:text-xl font-bold text-teal-700 mb-2 border-l-4 border-teal-400 pl-3"
            >
              {{ group.category }}
            </h2>

            <div
              v-for="(question, qIndex) in group.questions"
              :key="question._index"
              class="bg-white border border-gray-200 rounded-lg p-4 sm:p-6 shadow-sm"
            >
              <!-- 單選題 -->
              <div v-if="question.type === 'radio'" class="question-item">
                <label
                  class="block mb-4 text-lg font-semibold text-gray-800 text-left"
                >
                  <span class="text-red-500">*</span>
                  {{ qIndex + 1 }}. {{ question.question }}
                </label>
                <div class="space-y-2">
                  <div
                    v-for="(option, optIndex) in question.options"
                    :key="optIndex"
                    class="flex items-center p-3 rounded-lg hover:bg-gray-50 transition"
                  >
                    <input
                      v-model="formData.answers[question._index]"
                      type="radio"
                      :name="'question_' + question._index"
                      :value="option.value"
                      :id="'q' + question._index + '_opt' + optIndex"
                      class="w-4 h-4 text-teal-600 border-gray-300 focus:ring-teal-500 focus:ring-2"
                    />
                    <label
                      :for="'q' + question._index + '_opt' + optIndex"
                      class="ml-3 text-base text-gray-700 cursor-pointer flex-1"
                    >
                      {{ option.label }}
                    </label>
                  </div>
                </div>
              </div>

              <!-- 多選題 -->
              <div v-if="question.type === 'checkbox'" class="question-item">
                <label
                  class="block mb-4 text-lg font-semibold text-gray-800 text-left"
                >
                  <span class="text-red-500">*</span>
                  {{ qIndex + 1 }}. {{ question.question }}
                </label>
                <div class="space-y-2">
                  <div
                    v-for="(option, optIndex) in question.options"
                    :key="optIndex"
                    class="flex items-center p-3 rounded-lg hover:bg-gray-50 transition"
                  >
                    <Checkbox
                      v-model="formData.answers[question._index]"
                      :inputId="'q' + question._index + '_opt' + optIndex"
                      :value="option.value"
                      class="w-4 h-4"
                    />
                    <label
                      :for="'q' + question._index + '_opt' + optIndex"
                      class="ml-3 text-base text-gray-700 cursor-pointer flex-1"
                    >
                      {{ option.label }}
                    </label>
                  </div>
                </div>
              </div>

              <!-- 文字輸入題 -->
              <div v-if="question.type === 'text'" class="question-item">
                <label
                  class="block mb-4 text-lg font-semibold text-gray-800 text-left"
                >
                  <span v-if="question.required" class="text-red-500">*</span>
                  {{ qIndex + 1 }}. {{ question.question }}
                </label>
                <Textarea
                  v-model="formData.answers[question._index]"
                  class="w-full p-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 transition"
                  :rows="question.rows || 4"
                  :placeholder="question.placeholder || '請輸入您的回答...'"
                />
                <div
                  v-if="question.maxLength"
                  class="text-right text-xs sm:text-sm text-gray-500 mt-1"
                >
                  <span
                    :class="{
                      'text-red-500':
                        getAnswerLength(question._index) > question.maxLength,
                    }"
                  >
                    字數統計:
                    {{ getAnswerLength(question._index) }} /
                    {{ question.maxLength }}
                  </span>
                </div>
              </div>

              <!-- 評分題 (1-5分) -->
              <div v-if="question.type === 'rating'" class="question-item">
                <label
                  class="block mb-4 text-lg font-semibold text-gray-800 text-left"
                >
                  <span class="text-red-500">*</span>
                  {{ qIndex + 1 }}. {{ question.question }}
                </label>
                <div class="flex gap-2 w-full">
                  <label
                    v-for="rating in [1, 2, 3, 4, 5]"
                    :key="rating"
                    class="flex-1 flex items-center justify-center p-3 rounded-lg border-2 cursor-pointer transition"
                    :class="
                      formData.answers[question._index] == rating
                        ? 'border-teal-500 bg-teal-50'
                        : 'border-gray-300 hover:border-teal-300'
                    "
                  >
                    <input
                      v-model="formData.answers[question._index]"
                      type="radio"
                      :name="'rating_' + question._index"
                      :value="rating"
                      :id="'q' + question._index + '_rating' + rating"
                      class="sr-only"
                    />
                    <label
                      :for="'q' + question._index + '_rating' + rating"
                      class="text-lg font-semibold text-gray-700 cursor-pointer"
                    >
                      {{ rating }}分
                    </label>
                  </label>
                </div>
                <p class="text-sm text-gray-500 mt-2 text-center">
                  (1分：非常不同意，5分：非常同意)
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- 提交按鈕 -->
        <div class="mt-8 flex justify-center gap-4">
          <!-- TEST-ONLY: Remove before release (auto-fill all rating questions to 5) -->
          <!-- <button
            type="button"
            class="px-6 py-3 bg-amber-500 text-white border border-amber-600 rounded-lg font-medium shadow-sm transition hover:bg-amber-600 focus:outline-none focus:ring-2 focus:ring-amber-400"
            style="background-color: #f59e0b; color: #ffffff;"
            @click="fillAllRatingsToFive"
          >
            測試：全部填 5 分
          </button> -->
          <button
            type="button"
            class="px-8 py-3 bg-gray-300 text-gray-700 rounded-lg font-medium transition hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-500"
            @click="resetForm"
          >
            重置 / Reset
          </button>
          <button
            type="submit"
            class="px-8 py-3 text-white text-lg font-medium rounded-lg transition-all duration-300 ease-in-out transform hover:-translate-y-1 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-teal-500"
            style="background-color: #2db3b3"
            :disabled="isSubmitting"
          >
            <span v-if="!isSubmitting">提交問卷 / Submit</span>
            <span v-else>提交中...</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
import { useRouter } from "vue-router";
import axios from "axios";
import InputText from "primevue/inputtext";
import Textarea from "primevue/textarea";
import Checkbox from "primevue/checkbox";
import { ElNotification } from "element-plus";

const router = useRouter();
const isSubmitting = ref(false);
const formData = ref({
  studentId: "",
  studentName: "",
  email: "",
  phone: "",
  answers: [],
});

// 問卷題目
const questions = ref([]);
const isLoadingQuestions = ref(true);

// 依類別分組後的題目（使用後端提供的 category）
const groupedQuestions = computed(() => {
  const groupsMap = new Map();
  const groups = [];

  questions.value.forEach((q, index) => {
    const category = q.category || "未分類";
    if (!groupsMap.has(category)) {
      const group = { category, questions: [] };
      groupsMap.set(category, group);
      groups.push(group);
    }
    groupsMap.get(category).questions.push({ ...q, _index: index });
  });

  return groups;
});

const fetchQuestions = async () => {
  try {
    isLoadingQuestions.value = true;
    const response = await axios.get(
      process.env.VUE_APP_api_url + "/questionnaire/ability/questions"
    );
    if (response.data.status === true && response.data.data) {
      questions.value = response.data.data;
      initializeAnswers();
    } else {
      throw new Error("獲取題目失敗");
    }
  } catch (error) {
    console.error("獲取問卷題目錯誤:", error);
    ElNotification({
      title: "錯誤",
      message: "無法載入問卷題目，請稍後再試",
      type: "error",
    });
  } finally {
    isLoadingQuestions.value = false;
  }
};

// 初始化答案陣列
const initializeAnswers = () => {
  formData.value.answers = questions.value.map((q) => {
    if (q.type === "checkbox") {
      return [];
    }
    return "";
  });
};

// 獲取答案長度
const getAnswerLength = (index) => {
  const answer = formData.value.answers[index];
  return answer ? answer.length : 0;
};

// 驗證表單
const validateForm = () => {
  for (let i = 0; i < questions.value.length; i++) {
    const question = questions.value[i];
    const answer = formData.value.answers[i];

    if (question.required) {
      if (question.type === "checkbox") {
        if (!answer || answer.length === 0) {
          ElNotification({
            title: "驗證失敗",
            message: `請回答第 ${i + 1} 題：${question.question}`,
            type: "error",
          });
          return false;
        }
      } else if (question.type === "text") {
        if (!answer || answer.trim() === "") {
          ElNotification({
            title: "驗證失敗",
            message: `請回答第 ${i + 1} 題：${question.question}`,
            type: "error",
          });
          return false;
        }
        if (question.maxLength && answer.length > question.maxLength) {
          ElNotification({
            title: "驗證失敗",
            message: `第 ${i + 1} 題的字數超過限制（${question.maxLength}字）`,
            type: "error",
          });
          return false;
        }
      } else {
        if (!answer || answer === "") {
          ElNotification({
            title: "驗證失敗",
            message: `請回答第 ${i + 1} 題：${question.question}`,
            type: "error",
          });
          return false;
        }
      }
    }
  }
  return true;
};

// 提交問卷
const submitQuestionnaire = async () => {
  if (isSubmitting.value) {
    return;
  }

  if (!validateForm()) {
    return;
  }

  isSubmitting.value = true;

  try {
    const stuInfo = JSON.parse(sessionStorage.getItem("stuInfo"));
    if (!stuInfo) {
      throw new Error("無法獲取學生信息");
    }

    const currentDate = getTaipeiTimestamp();

    const dataToSend = {
      student_id: formData.value.studentId || stuInfo.userId,
      student_name: formData.value.studentName || stuInfo.userName,
      email: formData.value.email || "",
      phone: formData.value.phone || "",
      department: stuInfo.userDept || "",
      submission_time: currentDate,
      answers: formData.value.answers,
    };

    // 這裡替換為實際的 API 端點
    const response = await axios.post(
      process.env.VUE_APP_api_url + "/questionnaire/ability/submit",
      dataToSend
    );

    if (response.data && response.data.status === true) {
      window.alert("您的問卷已成功提交！");
      resetForm();
      router.push("/questionnaire/ability");
      return;
    }

    throw new Error(response.data?.message || "提交失敗");
  } catch (error) {
    console.error("提交失敗:", error);
    ElNotification({
      title: "錯誤",
      message: error.message || "提交失敗，請稍後再試",
      type: "error",
    });
  } finally {
    isSubmitting.value = false;
  }
};

const getTaipeiTimestamp = () => {
  const formatter = new Intl.DateTimeFormat("sv-SE", {
    timeZone: "Asia/Taipei",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });

  return formatter.format(new Date());
};

// 重置表單
const resetForm = () => {
  const stuInfo = JSON.parse(sessionStorage.getItem("stuInfo"));
  formData.value.studentId = stuInfo?.userId || "";
  formData.value.studentName = stuInfo?.userName || "";
  formData.value.email = "";
  formData.value.phone = "";
  initializeAnswers();
};

// TEST-ONLY: Remove before release (auto-fill rating questions to 5)
// const fillAllRatingsToFive = () => {
//   questions.value.forEach((question, index) => {
//     if (question.type === "rating") {
//       formData.value.answers[index] = 5;
//     }
//   });
// };

onMounted(async () => {
  // 檢查問卷是否在開放時間內
  try {
    const statusResponse = await axios.get(
      process.env.VUE_APP_api_url + "/questionnaire/ability/status"
    );
    
    if (statusResponse.data && statusResponse.data.status === true && statusResponse.data.data) {
      const isOpen = Boolean(statusResponse.data.data.is_open);
      
      if (!isOpen) {
        window.alert("問卷目前未開放填寫");
        router.push("/questionnaire/ability");
        return;
      }
    }
  } catch (error) {
    console.error("檢查問卷狀態失敗:", error);
    window.alert("無法確認問卷開放狀態，請稍後再試");
    router.push("/questionnaire/ability");
    return;
  }

  // 取得學生資訊
  const stuInfo = JSON.parse(sessionStorage.getItem("stuInfo"));
  if (stuInfo) {
    formData.value.studentId = stuInfo.userId || "";
    formData.value.studentName = stuInfo.userName || "";
  }
  formData.value.email = "";
  formData.value.phone = "";

  // 從後端取得問卷題目
  await fetchQuestions();

  // 隱藏Loading動畫
  setTimeout(() => {
    const loader = document.getElementById("loader");
    if (loader) {
      loader.classList.remove("is-active");
    }
  }, 500);
});
</script>

<style scoped>
.loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.9);
  z-index: 9999;
  transition: opacity 0.3s ease;
}

.loader.is-active {
  display: flex;
}

.loader:not(.is-active) {
  display: none;
}

.loader-area {
  position: relative;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
  width: 150px;
  height: 150px;
  background-color: #fff;
  border-radius: 10px;
  text-align: center;
}

.loader-inner {
  display: inline-block;
  margin: 20px;
}

.loader-image img {
  width: 80px;
  height: 80px;
}

.loader-text {
  margin-top: 20px;
  font-size: 18px;
  color: #666;
}

.question-item {
  width: 100%;
}

.form-group {
  margin-bottom: 1rem;
}

@media (max-width: 640px) {
  .form-group {
    padding: 0 0.5rem;
  }
}

:deep(.p-inputtext) {
  height: 48px;
  line-height: 48px;
  padding: 0.75rem 1rem !important;
  border-radius: 0.5rem;
}

:deep(.p-textarea) {
  border-radius: 0.5rem;
  min-height: 100px !important;
}

:deep(.p-inputtextarea) {
  font-size: 1rem !important;
  line-height: 1.5 !important;
  padding: 1rem !important;
  height: auto !important;
  resize: vertical;
}

:deep(.p-checkbox) {
  width: 20px;
  height: 20px;
}

:deep(.p-checkbox-box) {
  width: 20px;
  height: 20px;
  border-radius: 4px;
}
</style>
